"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.textureSources = void 0;
exports.textureSources = [
    {
        name: 'someTexture',
        type: 'texture',
        path: 'https://picsum.photos/seed/picsum/200/300'
    }
];
